__turbopack_context__.v({
  "Content": "post-module__S1Dk7q__Content",
  "Tools": "post-module__S1Dk7q__Tools",
});
